import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const KidsDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Kids Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>DOB</th>
                  <th>Gender</th>
                  <th>School Name</th>
                  <th>grade</th>
                </tr>
              </thead>
              <tbody>
                {employee?.employeeKidsDetail?.map((kid) => (
                  <tr key={kid.code}>
                    <td>{kid.kidName}</td>
                    <td>{kid.dateOfBirth && format(new Date(kid.dateOfBirth), "yyyy-MM-dd")}</td>

                    <td>{kid.gender}</td>
                    <td>{kid.schoolName}</td>
                    <td>{kid.grade}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

KidsDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default KidsDetails;
